import { defineMessages } from 'react-intl';

export default defineMessages({
	successDescription: {
		id: 'components.walletPayment.statusTransaction.success.successDescription',
		defaultMessage: 'پرداخت مشتری با موفقیت انجام شد!',
	},
	amountTitle: {
		id: 'components.walletPayment.statusTransaction.success.amountTitle',
		defaultMessage: 'مبلغ فاکتور:',
	},
	discountTitle: {
		id: 'components.walletPayment.statusTransaction.success.discountTitle',
		defaultMessage: 'تخفیف',
	},
	finalAmountTitle: {
		id: 'components.walletPayment.statusTransaction.success.finalAmountTitle',
		defaultMessage: 'مبلغ پرداختی مشتری:',
	},
	tryAgainButton: {
		id: 'components.walletPayment.statusTransaction.success.tryAgainButton',
		defaultMessage: 'اسکن بارکد جدید',
	},
	backButton: {
		id: 'components.walletPayment.statusTransaction.success.backButton',
		defaultMessage: 'برگشت به خانه',
	},
});
